<template>
  <div
    class="selected-hashtags"
    :class="{ 'is-visible': isVisible }"
  >
    <div class="container">
      <div class="grid">
        <div class="grid__left">
          <h3 class="title">{{hashtagsLength}}</h3>

          <div class="grid__items">
            <div v-for="item in items" :key="item" class="grid__items__item">{{item}}</div>			
          </div>
        </div>

        <div class="grid__right">
          <IconButton
            image="copy.svg"
            alt="ícone copiar"
            :icon-right="true"
            v-clipboard:copy="formattedashtagsList"
            v-clipboard:success="success"
          >Copiar</IconButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/buttons/IconButton'

export default {
  components: {
    IconButton,
  },
	props: {
		items: { type: Array, required: true }
	},
	computed: {
		hashtagsLength () {
			if(this.items.length == 1) {
				return `${this.items.length} hashtag selecionada`
			}

      return `${this.items.length} hashtags selecionadas`	
		},

		formattedashtagsList() {
			return this.items.join(' ')
		},

    isVisible () {
      return this.items.length
    }
	},

	methods: {
		success () {
      this.$emit('success')
    }
	}
}
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .grid {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    .title {
      margin-bottom: 12px;
    }

    &__right {
      flex: 0 1 auto;
    }

    &__items {
      display: flex;
      flex-wrap: wrap;
      font-size: 16px;
      margin-bottom: -8px;
      max-height: 90px;
      overflow: auto;

      & > *:not(:last-child) { 
        margin-right: 8px 
      }

      &__item {
        border-radius: 4px;
        padding: 4px 8px;
        margin-bottom: 8px;
        background: $purple10;
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;
    }
  }

.selected-hashtags {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
	background: $purple400;
  padding: 20px 0;
  z-index: 100;
  transform: translateY(100%);
  transition: none;

  &.is-visible { 
    transform: translateY(0); 
    transition: .5s transform;
  }
}
</style>